module.exports = __webpack_public_path__ + "static/fonts/Lato-Italic.56c4cb26.ttf";